/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type WardrobeGotoUpdateMutationVariables = Types.Exact<{
  skuId: Types.Scalars["ID"]["input"];
}>;

export type WardrobeGotoUpdateMutation = {
  __typename?: "Mutation";
  wardrobeGotoUpdate?: {
    __typename?: "WardrobeGotoUpdatePayload";
    result:
      | {
          __typename?: "WardrobeGotoUpdateError";
          code: Types.WardrobeGotoUpdateErrorCode;
          reason: string;
        }
      | {
          __typename?: "WardrobeGotoUpdateSuccess";
          successMessage: string;
          wardrobeGotoSkuIds: Array<string>;
          wardrobeGotoUpdateSuccess: boolean;
        };
  } | null;
};

export const WardrobeGotoUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "wardrobeGotoUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "skuId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "wardrobeGotoUpdate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "skuId" },
                      value: { kind: "Variable", name: { kind: "Name", value: "skuId" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "result" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "WardrobeGotoUpdateSuccess" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "successMessage" } },
                            { kind: "Field", name: { kind: "Name", value: "wardrobeGotoSkuIds" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "wardrobeGotoUpdateSuccess" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "InlineFragment",
                        typeCondition: {
                          kind: "NamedType",
                          name: { kind: "Name", value: "WardrobeGotoUpdateError" },
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "code" } },
                            { kind: "Field", name: { kind: "Name", value: "reason" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type WardrobeGotoUpdateMutationFn = Apollo.MutationFunction<
  WardrobeGotoUpdateMutation,
  WardrobeGotoUpdateMutationVariables
>;

/**
 * __useWardrobeGotoUpdateMutation__
 *
 * To run a mutation, you first call `useWardrobeGotoUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWardrobeGotoUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [wardrobeGotoUpdateMutation, { data, loading, error }] = useWardrobeGotoUpdateMutation({
 *   variables: {
 *      skuId: // value for 'skuId'
 *   },
 * });
 */
export function useWardrobeGotoUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    WardrobeGotoUpdateMutation,
    WardrobeGotoUpdateMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<WardrobeGotoUpdateMutation, WardrobeGotoUpdateMutationVariables>(
    WardrobeGotoUpdateDocument,
    options,
  );
}
export type WardrobeGotoUpdateMutationHookResult = ReturnType<typeof useWardrobeGotoUpdateMutation>;
export type WardrobeGotoUpdateMutationResult = Apollo.MutationResult<WardrobeGotoUpdateMutation>;
export type WardrobeGotoUpdateMutationOptions = Apollo.BaseMutationOptions<
  WardrobeGotoUpdateMutation,
  WardrobeGotoUpdateMutationVariables
>;
